import { useState } from "react";
import { format } from "date-fns";

export const useAPIGetJadwal = (props) => {
  const { uiContext, requestGet, filterValue } = props;

  const [listDataJadwalKeberangkatan, setListDataJadwalKeberangkatan] =
    useState([]);

  //  API call section

  const fetchListDataJadwalKeberangkatan = async (filterValueInput) => {
    const _filter =
      getFilterJadwalKeberangkatan(filterValueInput) +
      ";tanggal_transaksi:=:Null;data_kendaraan.data_kendaraan_jenis.nama:=:Trado";

    return requestGet({
      fullUrl: `/api/pemakaian/pemakaianmobil/data`,
      params: {
        page: 1,
        take: 500,
        filter: _filter,
        order: "tanggal_perkiraan_berangkat",
        order_method: "DESC",
        with_pemakai: 1,
        with_kendaraan: 1,
        with_trailer_berangkat: 1,
        with_trailer_pulang: 1,
        with_supir: 1,
        with_supir_pulang: 1,
        with_tujuan: 1,
      },
      onSuccess: async ({ pagination, message, data }) => {
        setListDataJadwalKeberangkatan(
          data.map((item, index) => ({ ...item, no: index + 1 }))
        );
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // other function section

  const getFilterJadwalKeberangkatan = (filterValueInput) => {
    const filters = [];

    const _filterValue = filterValueInput ?? filterValue;

    let filterDate = "";
    if (filterValue.dari) {
      filterDate += `tanggal_perkiraan_berangkat:>=:${format(
        _filterValue.dari,
        "yyyy-MM-dd"
      )} 00:00:00`;
    }

    if (_filterValue.sampai) {
      if (filterDate.length > 0) filterDate += ";";
      filterDate += `tanggal_perkiraan_berangkat:<=:${format(
        _filterValue.sampai,
        "yyyy-MM-dd"
      )} 23:59:59`;
    }

    if (filterDate !== "") filters.push(filterDate);

    if (_filterValue.data_kendaraan && _filterValue.data_kendaraan.id > 0) {
      filters.push(`kendaraan_id:=:${_filterValue.data_kendaraan.id}`);
    }

    return filters.join(";");
  };

  return {
    listDataJadwalKeberangkatan,
    fetchListDataJadwalKeberangkatan,
  };
};
